import { render, staticRenderFns } from "./datasubject-auto-processing-form.vue?vue&type=template&id=648986c2"
import script from "./datasubject-auto-processing-form.vue?vue&type=script&lang=js"
export * from "./datasubject-auto-processing-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports